import { render, staticRenderFns } from "./LivenessMovil.vue?vue&type=template&id=57ef2b59&scoped=true"
import script from "./LivenessMovil.vue?vue&type=script&lang=js"
export * from "./LivenessMovil.vue?vue&type=script&lang=js"
import style0 from "./LivenessMovil.vue?vue&type=style&index=0&id=57ef2b59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ef2b59",
  null
  
)

export default component.exports